import type { GsSettings } from "../../../api/groupSearchApi";
import { resolveTermLimit } from "./gsTermLimit";
import { resolveDeliveryTerm } from "./smartFiltersStorage";

/** Отдельное поле отличает новые 21–40 дней от прежнего max_time >= 21 («любой срок»). */
export const GS_INITIAL_DELIVERY_TERM_KEY = "lk_delivery_term_days_v1";

export function readGsDeliveryTerm(settings: Pick<GsSettings, "analyze" | "add_info">): number | null {
  const saved = settings.add_info?.[GS_INITIAL_DELIVERY_TERM_KEY];
  if (saved === null || resolveDeliveryTerm(saved) !== null) return resolveDeliveryTerm(saved);
  return resolveTermLimit(settings.analyze?.max_time);
}
